var map = {
	"./avatar.png": 5754,
	"./bubble.png": 2840,
	"./cabinet_box_icon.svg": 5778,
	"./cabinet_share_bg.svg": 8806,
	"./chatMic": 8153,
	"./chatMic.json": 8153,
	"./chat_message_from_audio.png": 8854,
	"./chat_message_list_icon.svg": 8359,
	"./chat_micphone_icon.svg": 5998,
	"./chat_speak_keybord.svg": 3920,
	"./chatbtnlottie": 8024,
	"./chatbtnlottie.json": 8024,
	"./close_black_icon.svg": 906,
	"./close_white_icon.svg": 4315,
	"./default-body-bg.svg": 2162,
	"./delete_button_icon.svg": 888,
	"./dots.gif": 7881,
	"./evaluation_detail_icon.svg": 2864,
	"./evaluation_edit_icon.svg": 1236,
	"./has_space_icon.svg": 5355,
	"./icon-card.png": 9470,
	"./icon-empty-card.svg": 8930,
	"./icon-empty-dark.png": 649,
	"./interactive_guidance": 2405,
	"./interactive_guidance.json": 2405,
	"./interactive_scene.svg": 5351,
	"./interactive_sequence.svg": 1338,
	"./linkard_logo.png": 4659,
	"./message_enterprise_version.svg": 850,
	"./message_home_premium.svg": 1064,
	"./message_professional_edition.svg": 4990,
	"./message_trial_version.svg": 5658,
	"./my_evaluation_icon.svg": 7561,
	"./next_black_icon.svg": 4524,
	"./next_white_icon.svg": 2954,
	"./no_space_icon.svg": 2638,
	"./question_analysis_icon.svg": 3748,
	"./review_problem_back.svg": 6618,
	"./scene_bg.svg": 1665,
	"./scene_bg1.svg": 3047,
	"./share-my.jpg": 8488,
	"./show_listen_icon.svg": 5341,
	"./social_media_arrow.svg": 8590,
	"./star.png": 8798,
	"./trigger_play.png": 8202,
	"./umi_audio_ani": 1027,
	"./umi_audio_ani.json": 1027,
	"./umi_audio_listen_loading": 8994,
	"./umi_audio_listen_loading.json": 8994,
	"./umi_call_going.svg": 9092,
	"./umi_call_normall.svg": 5000,
	"./umi_listen_close.svg": 6610,
	"./white_btn_icon.svg": 2866
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9300;